/**
 * @module payoutMethod
 * @description A list of payment methods
 */
export const payoutMethod = [
	'card',
	'eft',
	'wallet',
	'cash',
	'voucher',
	'other',
] as const;
export type PayoutMethod = (typeof payoutMethod)[number];
